<template>
	<v-card>
		<v-card-title>Manage Permissions</v-card-title>
		<v-data-table :headers="columns" :items="rows">
			<template v-slot:item.role="{item}">{{prettyPrint(item.role, 'TITLE')}}</template>
			<template v-for="p in permissions" v-slot:[`item.${p}`]="{ item }">
				<v-switch :key="p" v-model="item[p]" :value="true"></v-switch>
			</template>
		</v-data-table>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="green" dark @click="savePermissions">Save</v-btn>
		</v-card-actions>
	</v-card>	
</template>

<script>
	import Vuex from "vuex"
	import {prettyPrint} from "../../assets/utilities.js";
	export default{
		name: "PermissionManager", 
		props: {
			permissions: {type: Array, default: () => [] }, 
			object: {type: Object }, 
			objectType: {type: String}
		}, 
		computed: {
			...Vuex.mapState({
				clients(state){
					return state.admin.clients
				}
			}),
			users(){
				const self = this;
				var users = this.object.users;
				var clients = Object.keys(users).filter( u => {
					return users[u] == "client";
				})

				return clients.map( c => {
					return self.clients.find( client => client.id == c )
				})
			}, 
			columns(){
				var columns = [
					{text: 'User', value: 'user'},
					{text: 'Role', value: 'role'}
				]
				this.permissions.forEach( p => {

					columns.push( {
						text: prettyPrint(p, "TITLE"),
						value: p
					} )
				})
				return columns;
			}, 
			rows(){
				const self = this;
				return self.users.map( u => {
					var row = {
						id: u.id, 
						user: u.displayName,
						role: u.role, 
					}
					self.permissions.forEach( p => {
						row[p] = false;
					})
					if( self.object.permissions[u.id] ){
						for( var key in self.object.permissions[u.id]){
							row[key] = self.object.permissions[u.id][key]
						}
					}
					return row;
				})				
			},
		},
		methods: {
			prettyPrint: prettyPrint, 
			permissionObject(){
				const self = this;
				var obj = {}
				self.rows.forEach( r => {
					obj[r.id] = {}
					self.permissions.forEach( p => {
						obj[r.id][p] = r[p];
					})

				})
				return obj;
			},
			savePermissions(){
				this.object.permissions = this.permissionObject();
				this.$store.dispatch( "updateDoc", {
					doc: this.objectType +"/"+ this.object.id,
					data: {
						permissions: this.object.permissions
					}, 
					action: "update"
				})
				this.$emit("complete");
			}
		}
	}
</script>